( function () {
	'use strict';

	// blur element when enter key is pressed
	function keyBlur () {
		function link ( scope, elem ) {
			elem.bind( 'keydown', function ( e ) {
				if ( e.keyCode === 13 ) {
					elem[ 0 ].blur();
				}
			} );
		}

		return {
			'restrict' : 'A',
			'link'     : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'keyBlur', keyBlur );
} )( );
